<template>
  <v-list-tile>
    <v-list-tile-action>
      <v-icon>receipt</v-icon>
    </v-list-tile-action>

    <v-list-tile-content>
      <v-list-tile-title class="font-weight-medium">
        Pagamento de Contas
        <v-icon small>help_outline</v-icon>
      </v-list-tile-title>
      <v-list-tile-sub-title v-if="partner === 'establishment'">
        Pague seus boletos bancários ou de concessionárias direto da sua conta digital
        {{ account.fantasy_name }}.
      </v-list-tile-sub-title>
      <v-list-tile-sub-title v-else>
        Pague seus boletos bancários ou de concessionárias direto da sua conta digital
        {{ partnerName }}.
      </v-list-tile-sub-title>
    </v-list-tile-content>

    <v-list-tile-action>
      <v-btn outline color="indigo" @click="newBillPaymentForm">&nbsp;Realizar Pagamento&nbsp;</v-btn>
    </v-list-tile-action>
    <new-bill-payment-form />
  </v-list-tile>
</template>
<script>
import { EventBus } from "@/services/event-bus";
import { mapGetters } from 'vuex';
export default {
  name: "NewBillPayment",
  created() {
    this.$store.dispatch('account/getAccount');
  },
   computed: {
    ...mapGetters({
      account: 'account/account',
      partner: 'account/partner',
      partnerName: 'account/partnerName',
      billErrors: "bills/billPaymentError"
    }),
    paymentProvider() {
      return (this.account && this.account.bill_source) || 'banco_abc';
    }
  },
  components: {
    newBillPaymentForm: () =>
      import(
        "@/components/desktop/bills/actions/NewBillPaymentForm.vue"
      )
  },
  methods: {
    newBillPaymentForm() {
      EventBus.$emit("show-new-bill-payment-form");
    }
  }
};
</script>
